import { createFileRoute, redirect } from '@tanstack/react-router';
import { PreferredLocationsPage } from '../components/profile/PreferredLocationsPage';

export const Route = createFileRoute('/profile/preferred-locations')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/sign-in', search: { redirect: location.pathname } });
    }
  },
  component: PreferredLocationsPage,
});
